import { apiClient } from '@/services'

import { asAgentView, type AgentView } from '../types'

const base = (orgId: string): string => `/${encodeURIComponent(orgId)}/agents`

/** Organisation-scoped agent catalogue transport boundary. */
export const agentsService = {
  async listAgents(orgId: string): Promise<AgentView[]> {
    const rows = await apiClient.get<unknown[]>(base(orgId))
    return rows.map(asAgentView).filter((row): row is AgentView => row !== null)
  },
}
